<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-detail-config-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.display }}</span>
    </v-row>
    <v-col class="com-pc-card-contents space-stg">
      <v-row no-gutters>
        <span class="px-2" v-if="dispGraph()">
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="timeMode === false"
            @click="timeMode = true"
            >{{ btn.timehour }}</v-btn
          >
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="timeMode === true"
            @click="timeMode = false"
            >{{ btn.time10 }}</v-btn
          >
        </span>
        <span class="px-2" v-if="dispGraph()">
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === true"
            @click="scalMode = false"
            >{{ btn.zoomout }}</v-btn
          >
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === false"
            @click="scalMode = true"
            >{{ btn.zoomin }}</v-btn
          >
        </span>
      </v-row>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.contents }}</span>
      <span class="com-pc-legend-btn" v-if="dispGraph()">
        <v-btn
          depressed
          x-small
          class="ma-1"
          color="orange"
          max-width="70px"
          dark
          :outlined="!isLegendDisp"
          @click="isLegendDisp = !isLegendDisp"
          :style="{ width: this.legendWidth + 'px' }"
          min-width="0px"
        >
          <span v-bind:style="{ fontSize: this.legendFontSize + 'px' }">
            {{ btn.legend }}
          </span>
          <span
            v-bind:style="{ fontSize: this.legendFontSize + 'px' }"
            v-if="isLegendDisp"
            >{{ btn.legendOn }}</span
          >
          <span
            v-bind:style="{ fontSize: this.legendFontSize + 'px' }"
            v-else
            >{{ btn.legendOff }}</span
          >
        </v-btn>
      </span>
    </v-row>
    <v-col class="com-pc-card-contents space-stg">
      <v-checkbox
        v-model="obsDispStatus.riverWarnInfo"
        :label="contents.riverWarnInfo"
        class="ma-0"
        hide-details
        v-if="this.detailRwList && this.detailRwList.length > 0"
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.info"
        :label="contents.info"
        class="ma-0"
        hide-details
        v-if="this.detailInfoList && this.detailInfoList.length > 0"
      ></v-checkbox>
      <v-checkbox
        v-if="enabledXsec"
        v-model="obsDispStatus.xsec"
        :label="contents.xsec"
        class="ma-0"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-if="enabledCctv"
        v-model="obsDispStatus.cctv"
        :label="contents.cctv"
        class="ma-0"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.obsGraph"
        :label="contents.waterGraph"
        class="ma-0"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.graphSwitch.rainGraph"
        :label="contents.rainGraph"
        class="ma-0 pl-4"
        hide-details
        :disabled="!obsDispStatus.obsGraph"
        v-if="dispGraph() ? dispGraphRain() : false"
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.valuesList"
        :label="contents.valuesList"
        class="ma-0"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.sns }}</span>
    </v-row>
    <v-col class="com-pc-card-contents space-stg">
      <tm-detail-sns :dispContentsSwitch="!obsDispStatus.cctv"></tm-detail-sns>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]水位 表示切替カード
 * TmStageDetailConfig.vue
 * @author ILUKE
 */
import TmDetailSns from "./TmDetailSns.vue";
export default {
  name: "tm-stage-detail-config",
  components: {
    TmDetailSns,
  },
  props: {
    enabledCctv: {
      type: Boolean,
      require: true,
    },
    enabledXsec: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      panel: {
        display: "表示切替",
        legend: "凡例",
        contents: "内容表示",
        sns: "SNS投稿",
      },
      contents: {
        riverWarnInfo: "河川予警報情報",
        info: "お知らせ情報",
        xsec: "横断図",
        cctv: "河川カメラ",
        waterGraph: "水位グラフ",
        rainGraph: "雨量グラフ",
        valuesList: "観測値一覧",
      },
      btn: {
        timehour: "時間毎",
        time10: "10分毎",
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
        legendOn: "(on)",
        legendOff: "(off)",
      },
      legendWidth: 70,
      legendFontSize: 1,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    /** 拡縮表示設定 */
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    /** 表示時刻設定 */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    /** 凡例表示状態 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /** コンテンツ切替 */
    obsDispStatus: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus;
      },
    },
    /** 河川予警報情報 */
    detailRwList() {
      return this.$store.state.map.riverWarnInfo;
    },
    /** お知らせ情報 */
    detailInfoList() {
      return this.$store.state.map.information;
    },
    /** 通常水位情報取得 */
    tmStageList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
  },
  methods: {
    dispGraphRain() {
      if (
        this.tmStageList.length !== 0 &&
        !this.tmStageList.tmStgDetailInfo.reprnOfcCd
      ) {
        return false;
      }
      return true;
    },
    /**
     * グラフ表示判定
     */
    dispGraph() {
      if (
        this.tmStageList.length !== 0 &&
        (this.tmStageList.graph.hour.value.length > 0 ||
          this.tmStageList.graph.min10.value.length > 0)
      ) {
        return true;
      }
      return false;
    },
    handleResize() {
      if (this.$vuetify.breakpoint.sm) {
        this.legendWidth = 50;
        this.legendFontSize = 0.5;
      } else {
        this.legendWidth = 70;
        this.legendFontSize = 12;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.com-pc-card-header {
  .com-pc-legend-btn {
    position: absolute;
    right: 0;
  }
}
</style>
